/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var activeBookLang;

(function ($) {

    var hamburgerIcon = new SVGMorpheus('#hamburger-graphic');
    if (!window.location.origin) {
        window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }

    var Sage = {
        'common': {
            init: function () {
                this.navEvents();
                this.checkoutQtyUpdate();
                this.leLivreLangs();
            },
            woocommerce: {
                applyCouponBtn: function () {
                    return $('input[name=apply_coupon]');
                }
            },
            loadURL: function (target) {

                function screenTransitions() {
                    $('.transition:not(.active) .tr-effect').removeClass('tr-action');
                    $('.transition.active .tr-effect').each(function (i, v) {
                        $(this).addClass('tr-action');
                        i = i === 0 ? 0.1 : i * 0.15;
                        $(this).css({
                            transitionDelay: i + 's'
                        });
                    });
                }

                var targetURL = String(target);
                var targetURLsplit = targetURL.split("#");
                var targetID = targetURLsplit[1] !== undefined ? '#' + targetURLsplit[1] : undefined;
                if (targetID !== undefined) {
                    $('main.main section.screen').removeClass('active');
                    $(targetID).addClass('active');
                    screenTransitions();
                    if (String(window.location.href) !== targetURLsplit[0] && window.location.origin !== targetURL) {
                        window.location.href = targetURL;
                    }
                } else {
                    if (window.location.href !== targetURL) {
                        window.location.href = targetURL;
                    } else {
                        $('main.main section.screen').removeClass('active');
                        $('main.main section.screen').first().addClass('active');
                        screenTransitions();
                    }
                }

                $('main.main section.screen').trigger('activeChanged');
            },
            checkoutQtyUpdate: function () {
                $('.update-product-qty').on('change', function (e) {
                    var qty = parseInt($(this).val());
                    var cart_item_key = $(this).data('citem');
                    $.ajax({
                        method: 'POST',
                        url: JSsend.ajaxurl,
                        beforeSend: function () {
                            $('.order-total span.amount').text('Calculer...');
                        },
                        data: {
                            action: 'addCartItemQty',
                            cart_item_key: cart_item_key,
                            cart_item_qty: qty
                        }
                    }).done(function (response) {
                        var total = response;
                        $('.order-total span.amount').html(total);
                        $.ajax({
                            method: 'POST',
                            url: JSsend.ajaxurl,
                            data: {
                                action: 'showCartItems',
                                is_ajax: true
                            }
                        }).done(function (response) {
                            $('#nav-cart-items-box').html(response);
                        });
                    });
                });
            },
            nav: {
                getItems: function (hovered) {
                    return $('.nav-primary .nav .menu-item' + (hovered !== undefined ? '.hovered' : ''));
                }
            },
            navEvents: function () {
                this.nav.getItems().first().addClass('hovered');
                function bakingHamburger() {
                    if (window.innerWidth < 1060) {
                        $('#hamburger-graphic').width(30);
                        $('#hamburger-graphic').height(30);
                    } else {
                        $('#hamburger-graphic').width(50);
                        $('#hamburger-graphic').height(50);
                    }
                }
                bakingHamburger();
                $(window).resize(function () {
                    bakingHamburger();
                });
                $('.nav-primary .js-load a').on('click', function (e) {
                    e.preventDefault();
                    localStorage.setItem("come-from-menu", true);
                    var href = window.location.origin + '/' + $(this).attr('href');
                    Sage.common.loadURL(href);
                    $('.nav-full-screen').toggleClass('in');
                    $('.btn-hamburger').removeClass('in');
                    hamburgerIcon.to('hamburger-graphic-hamburger', {
                        easing: 'expo-in-out'
                    });
                });
                $(document).on('keyup', function (e) {
                    var enterKey = 13;
                    var escapeKey = 27;
                    function closeMenu() {
                        $('.btn-hamburger').toggleClass('in');
                        if ($('.btn-hamburger').hasClass('in')) {
                            hamburgerIcon.to('hamburger-graphic-close', {
                                easing: 'expo-in-out'
                            });
                        } else {
                            hamburgerIcon.to('hamburger-graphic-hamburger', {
                                easing: 'expo-in-out'
                            });
                        }

                        $('.nav-full-screen').toggleClass('in');
                    }

                    if (e.keyCode === escapeKey) {
                        closeMenu();
                    }


                    if ($('.btn-hamburger').hasClass('in')) {
                        if (e.keyCode === 38 && Sage.common.nav.getItems(true).index() !== 0) {

                            var prev = Sage.common.nav.getItems()
                                    .get(Sage.common.nav.getItems(true).index() - 1);
                            Sage.common.nav.getItems().removeClass('hovered');
                            $(prev).addClass('hovered');
                        } else if (e.keyCode === 40 && Sage.common.nav.getItems(true).index() !== (Sage.common.nav.getItems().length - 1)) {

                            var next = Sage.common.nav.getItems()
                                    .get(Sage.common.nav.getItems(true)
                                            .index() + 1);
                            Sage.common.nav.getItems().removeClass('hovered');
                            $(next).addClass('hovered');
                        } else if (e.keyCode === enterKey) {

                            closeMenu();
                            Sage.common.loadURL(Sage.common.nav.getItems(true)
                                    .find('a')
                                    .attr('href'));
                        }

                    }

                });
                $('.btn-hamburger').on('click', function (e) {
                    $(this).toggleClass('in');
                    if ($(this).hasClass('in')) {
                        hamburgerIcon.to('hamburger-graphic-close', {
                            easing: 'expo-in-out'
                        });
                    } else {
                        hamburgerIcon.to('hamburger-graphic-hamburger', {
                            easing: 'expo-in-out'
                        });
                    }

                    $('.nav-full-screen').toggleClass('in');
                });

                $('.nav-fullscreen .nav-primary .nav .menu-item a').on('click', function (e) {
                    e.preventDefault();
                    loadURL($(this).href());
                });
            },
            leLivreLangs: function () {
//                $('#le-livre').append($('#le-livre-langs'));
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
                this.sectionScreensEvents();
                Sage.common.loadURL(window.location);
            },
            turnBook: function () {
                var langChooser = $('#le-livre-langs');
                $('#language-chooser-box').append(langChooser);

                activeBookLang = $('#language-chooser-box .current-sample-book').data('href');
 
                $('.download-the-sample-book').attr('href', activeBookLang);

                var downloadBook = $('#download-the-book-sample');
            },
            sectionScreensEvents: function () {

                function screenSpecificMethods() {
                    if ($('.screen.active').hasClass('fifth-skill')) {
                        setTimeout(function () {
                            $('.fifth-skill-img').addClass('fade-in-fifth-skill');
                            $('.static-image-box .small-line').addClass('fade-in-fifth-skill');
                        }, 1000);
                        setTimeout(function () {
                            $('.fifth-skill-inserted-content').addClass('fade-in-fifth-skill');
                        }, 1300);
                    } else {
                        $('.fifth-skill-img').removeClass('fade-in-fifth-skill');
                        $('.static-image-box .small-line').removeClass('fade-in-fifth-skill');
                        $('.fifth-skill-inserted-content').removeClass('fade-in-fifth-skill');
                    }

                }

                function logoToScreen() {
                    var logoPath = $('.brand-fixed svg g path');
                    var color;
                    if (($('main.main section.screen.active').hasClass('picture-bg') || $('main.main section.screen.active').hasClass('blue') || $('main.main section.screen.active').hasClass('initiative')) && screen.width > 992) {
                        color = '#ffffff';
                    } else {
                        color = '#000000';
                    }
                    logoPath.css({
                        fill: color
                    });
                }

                var fifthSkill = $('#fifth-skill-text-content').html();
                $('.fifth-skill').html($('#fifth-skill-content'));
                $('.fifth-skill-inserted-content').html(fifthSkill);
                $('main.main section.screen').addClass('transition');
                logoToScreen();

                function changeScreen(prevOrNext) {

                    var activeScreenIndex = $('main.main section.screen.active').index();
                    switch (prevOrNext) {

                        case 'prev':
                            if (activeScreenIndex !== 0) {
                                $('main.main section.screen').removeClass('active');
                                $($('main.main section.screen')
                                        .get(activeScreenIndex - 1))
                                        .addClass('active');
                                $('main.main section.screen').trigger('activeChanged');
                            }
                            break;
                        case 'next':
                            if (activeScreenIndex !== $('main.main section.screen').length - 1) {
                                $('main.main section.screen').removeClass('active');
                                $($('main.main section.screen')
                                        .get(activeScreenIndex + 1))
                                        .addClass('active');
                                $('main.main section.screen').trigger('activeChanged');
                            }
                            break;
                    }

                }

                $('main.main section.screen').on('activeChanged', function (e) {

                    logoToScreen();
                    window.location.hash = '#' + $('main.main section.screen.active').attr('id');

                    screenSpecificMethods();
                    $('.transition:not(.active) .tr-effect').removeClass('tr-action');
                    $('.transition.active .tr-effect').each(function (i, v) {
                        $(this).addClass('tr-action');
                        i = i === 0 ? 0.1 : i * 0.15;
                        $(this).css({
                            transitionDelay: i + 's'
                        });
                    });
                });

                $(document).on('keyup', function (e) {
                    var leftKey = 37;
                    var rightKey = 39;
                    if (e.keyCode === leftKey) {
                        changeScreen('prev');
                    } else if (e.keyCode === rightKey) {
                        changeScreen('next');
                    }
                });

                $('.screen-navbar .prev-screen-btn').on('click', function (e) {
                    e.preventDefault();
                    changeScreen('prev');
                });
                $('.screen-navbar .next-screen-btn').on('click', function (e) {
                    e.preventDefault();
                    changeScreen('next');
                });

            },
            finalize: function () {
                this.turnBook();
            }
        },
        'woocommerce_checkout': {
            init: function () {
                this.events();
            },
            events: function () {
                $('.woocommerce-checkout #order_review #payment_information .btn-black').removeClass('top_coupon');
                $('.woocommerce-checkout #order_review #payment_information .btn-black').addClass('bottom_coupon');
                $('.woocommerce-checkout #order_review #payment_information .coupon-form-row .input-text').removeClass('top_coupon_input');
                $('.woocommerce-checkout #order_review #payment_information .coupon-form-row .input-text').addClass('bottom_coupon_input');
                $('.bottom_coupon').on('click', function (e) {
                    e.preventDefault();
                    var codeval = $('.bottom_coupon_input').val();
                    $('.top_coupon_input').val(codeval);
                    $('.top_coupon').trigger('click');
                    $('.update-product-qty').trigger('change');
                });
            }
        },
        'error404': {
            init: function () {
                this.vibration();
            },
            vibration: function () {
                setInterval(function () {
                    $('.screen-not-found .center-error .top span').css({
                        transform: 'translateX(' + Math.round(Math.random() * 20) + 'px)'
                    });
                    $('.screen-not-found .center-error .noise').css({
                        transform: 'translateX(' + Math.round(Math.random() * 20) + 'px)'
                    });
                    $('.screen-not-found .center-error .bottom span').css({
                        transform: 'translateX(' + Math.round(Math.random() * 20) + 'px)'
                    });
                }, 10);
            }
        }
    };
    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';
            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');
            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });
            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };
    // Load Events
    $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
